<template>
  <div class="mb-24px">
    <hr class="is-marginless" />
    <div v-for="(item, index) of fragment.items" :key="index">
      <ui-drawer>
        <template slot="title">{{ $prismicText(item.drawer_title) }}</template>
        <prismic-rich-text class="content is-custom" :field="item.drawer_content" />
      </ui-drawer>
      <hr class="is-marginless" />
    </div>
  </div>
</template>

<script>
import UiDrawer from '@/components/ui/drawer'

export default {
  components: {
    UiDrawer
  },
  props: {
    fragment: Object
  }
}
</script>
